import { Icon } from '@chakra-ui/react';

export const CustomAnalyticsIcon = (props) => (
  <Icon viewBox="0 0 30 30" width="30px" height="30px" {...props}>
    <path
      className="multicolorElToDark darkBgElToBrand"
      d="M3.75 1.875H1.875V26.25C1.875 26.7473 2.07254 27.2242 2.42417 27.5758C2.77581 27.9275 3.25272 28.125 3.75 28.125H28.125V26.25H3.75V1.875Z"
      fill="#FFFFFF"
    />
    <path
      className="multicolorElToDark darkBgElToBrand"
      d="M28.125 8.4375H21.5625V10.3125H24.9281L17.8125 17.4281L13.7906 13.3969C13.7035 13.309 13.5998 13.2393 13.4855 13.1917C13.3713 13.1441 13.2488 13.1196 13.125 13.1196C13.0012 13.1196 12.8787 13.1441 12.7645 13.1917C12.6502 13.2393 12.5465 13.309 12.4594 13.3969L5.625 20.2406L6.94687 21.5625L13.125 15.3844L17.1469 19.4156C17.234 19.5035 17.3377 19.5732 17.452 19.6208C17.5662 19.6684 17.6887 19.6929 17.8125 19.6929C17.9363 19.6929 18.0588 19.6684 18.173 19.6208C18.2873 19.5732 18.391 19.5035 18.4781 19.4156L26.25 11.6344V15H28.125V8.4375Z"
      fill="#FFFFFF"
    />
  </Icon>
);
